import Gauge from "./gauge";

export default Gauge;



// WEBPACK FOOTER //
// ./casper/sass/components/gauge/index.js